export const MediaType = {
  UNKNOWN: 0,
  MJPG: 'MJPEG',
  JPG: 2,
  FLV: 'FLV',
  MP4: 4,
  REPLAY: 5, //錄影回放
  IFRAME: 6,
  HTML: 'HTML',
  RTSP: 'RTSP',
}
